import React from 'react';
import Button from '../ui/Button';
function PrimaryActionSplitButton({
  label = 'New',
  onPrimaryClick,
  menuItems = [],
}) {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="relative inline-flex items-stretch">
      <Button
        type="button"
        variant="primary"
        aria-label="Open action menu"
        onClick={() => setOpen(value => !value)}
        className="px-2 py-2 bg-axial-600 hover:bg-axial-700 text-white text-sm font-medium rounded-lg transition-colors"
      >
        New +
      </Button>

      {open && menuItems.length > 0 && (
        <div className="absolute right-0 top-full mt-1 z-20 min-w-44 rounded-lg border border-gray-700 bg-gray-900 p-1 shadow-xl">
          {menuItems.map(item => (
            <button
              key={item.key}
              type="button"
              onClick={() => {
                item.onClick?.();
                setOpen(false);
              }}
              className="block w-full rounded-md px-3 py-2 text-left text-sm text-gray-200 hover:bg-gray-800"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default PrimaryActionSplitButton;